export default __webpack_public_path__ + "static/media/fac-QC.83a99b65.jpg";